<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-accordion>
    <p-accordionTab header="{{ 'PRODUCTO.LBL_RESTRICCIONESOFI' | translate }}" *ngIf="!carInformacionInicial"
                    [selected]="tab ==='OFI'">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'PRODUCTO.LBL_ZONAL' | translate }}</label>
              <p-dropdown disableTab  id="idAgrupacion" name="nomIdAgrupacion"
                          [options]="lisAgrupaciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                          (onChange)="cambiarAgrupacion($event.value)"
                          [(ngModel)]="agrupacionSeleccionada"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-5 lg:col-5">
            <div class="card card-w-title">
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <label>{{ 'PRODUCTO.LBL_OFICINAS' | translate}}</label>
                </div>
                <div class="col-12 md:col-12 lg:col-12">
                  <p-listbox [options]="listaProductoRestriccionOficina" [(ngModel)]="productoRestriccionOficina" filter="filter"
                             [listStyle]="{'max-height':'250px'}"  optionLabel="nombreOficina" class="p-picklist-pl-unset"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
                  </p-listbox>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-2 lg:col-2 text-center" style="margin-top: 100px;">
            <button type="button" class="p-button btn" icon="fa fa-chevron-circle-right" data-toggle="tooltip"
                    title="{{'BTN_TRASLADAR' | translate}}"
                    pButton (click)="restringir(productoRestriccionOficina, true)"></button>
            <br><br>
            <button type="button" class="p-button btn" icon="fa fa-angle-double-right" data-toggle="tooltip"
                    title="{{'BTN_TRASLADAR' | translate}}"
                    pButton (click)="restringirTodos( true )"></button>
            <br><br>
            <button type="button" class="p-button btn" icon="fa fa-chevron-circle-left" data-toggle="tooltip"
                    title="{{'BTN_TRASLADAR' | translate}}"
                    pButton (click)="restringir(productoRestriccionOficinaRestringido,false)"></button>
            <br><br>
            <button type="button" class="p-button btn" icon="fa fa-angle-double-left" data-toggle="tooltip"
                    title="{{'BTN_TRASLADAR' | translate}}"
                    pButton (click)="restringirTodos( false )"></button>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <div class="card card-w-title">
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <label>{{ 'PRODUCTO.LBL_OFICINASNOPRODUC' | translate}}</label>
                </div>
                <div class="col-12 md:col-12 lg:col-12">
                  <p-listbox [options]="listaProductosRestriccionOficinaRestringidos " [(ngModel)]="productoRestriccionOficinaRestringido"
                             [listStyle]="{'max-height':'250px'}" filter="filter" optionLabel="nombreOficina" class="p-picklist-pl-unset"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
                  </p-listbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="regresarFormulario()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      (click)="onSubmit()"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

    </p-accordionTab>
    <p-accordionTab header="{{ 'PRODUCTO.LBL_ASIGNACIONGEOGRAFICA' | translate }}" *ngIf="!carInformacionInicial"
                    [selected]="tab ==='GENE'" >
      <app-producto-restriccion-barrios [producto]="producto" ></app-producto-restriccion-barrios>
    </p-accordionTab>
    <p-accordionTab header="{{ 'PRODUCTO.LBL_RESTRICCIONESSUBDESTINOS' | translate }}" *ngIf="!carInformacionInicial"
                    [selected]="tab ==='SUB'" >
                    <app-producto-restriccion-subdestino [producto]="producto"></app-producto-restriccion-subdestino>
    </p-accordionTab>
    <p-accordionTab header="{{ 'PRODUCTORESTRICCIONES.LBL_RESTRICCIONESTIPOACTIVIDAD' | translate }}" *ngIf="!carInformacionInicial"
                    [selected]="tab ==='TIPACT'" >
                    <app-producto-restriccion-actividad [producto]="producto"></app-producto-restriccion-actividad>
    </p-accordionTab>
  </p-accordion>

</div>

<p-confirmDialog #cd key="producto-restriccion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
